export const checkIsCrossLicenseDealType = (currentDealTypeList: string[]) => {
  return currentDealTypeList.some(
    (dealType) => dealType.toLowerCase() === "cross license agreement",
  );
};
